import * as Yup from "yup";

import { Alert, Divider, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";

import PrimaryButton from "../../../../components/custom/PrimaryButton";
import SecondaryButton from "../../../../components/custom/SecondaryButton";
import TextField from "../../../../components/custom/TextField";
import { login } from "./loginService";
import { styled } from "@mui/system";
import useAuth from "../../../../hooks/useAuth";
import { useMutation } from "react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  avatarAtom,
  publisherNameAtom,
  userFullNameAtom,
  userRoleAtom,
  userRoleDisplayDescriptionAtom,
} from "../../../../atom/atoms";
import { useAtom } from "jotai";

const StyledDivider = styled(Divider)`
  align-self: center;
  justify-self: center;
  display: flex;

  &.MuiDivider-root {
    border-color: ${(props) => props.theme.palette.background.mouseGrey};

    height: 0.125rem;
  }
`;

const StyledTypography = styled(Typography)`
  width: 80%;
  ${(props) => props.theme.breakpoints.down("sm")} {
    width: 100%;
    text-align: center;
    font-size: 10px;
  }
`;

const Login = () => {
  const { t } = useTranslation();
  const [error, setError] = useState("");
  const [{ setAuthState }] = useAuth();
  const navigate = useNavigate();
  const [, setAvatar] = useAtom(avatarAtom);
  const [, setPublisherName] = useAtom(publisherNameAtom);
  const [, setUserRole] = useAtom(userRoleAtom);
  const [, setUserRoleDisplayDescription] = useAtom(
    userRoleDisplayDescriptionAtom
  );
  const [, setUserFullName] = useAtom(userFullNameAtom);

  const { mutate: loginMutate } = useMutation(login, {
    onSuccess: ({
      data: { user, customer, publisherName, admin, menuMap, avatarUrl },
    }) => {
      setAuthState(user, customer, menuMap, true, false, admin);
      window.sessionStorage.setItem("user", JSON.stringify(user));
      window.sessionStorage.setItem("customer", JSON.stringify(customer));
      window.sessionStorage.setItem("routes", JSON.stringify(menuMap));
      setAvatar(avatarUrl);
      setPublisherName(publisherName);
      setUserRole(user?.role?.description);
      setUserRoleDisplayDescription(user?.role?.displayDescription);
      setUserFullName(user?.firstName + " " + user?.lastName);
    },
    onError: (error) => {
      console.error(error);

      switch (error.response.status) {
        case 401: {
          setError(t("User not authenticated"));
          break;
        }
        default: {
          setError(error.message);
          setTimeout(() => setError(null), 5000);
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Field is required"),
    password: Yup.string().required("Field is required"),
    // .max(16, "Max is 16 charactres"),
  });
  return (
    <Formik
      initialValues={{ username: "", password: "" }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, setStatus }) => {
        loginMutate(values);
        setSubmitting(false);
      }}
    >
      {({
        submitForm,
        isSubmitting,
        touched,
        errors,
        setFieldValue,
        values,
        status,
        handleSubmit,
      }) => (
        <Form>
          <Grid container sx={{ width: "100%" }} spacing={5}>
            <Grid item xs={12} sx={{ marginTop: 10 }}>
              {error && (
                <Alert sx={{ marginTop: 5, marginBottom: 5 }} severity="error">
                  {error}
                </Alert>
              )}
              <TextField
                required
                label="Username"
                name="username"
                placeholder={t("Your username")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                label={t("Password")}
                name="password"
                placeholder={t("Your password")}
                type="password"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
                marginTop: 10,
              }}
            >
              <SecondaryButton
                sx={{ fontSize: [10, 14] }}
                variant="text"
                onClick={() => navigate("/auth/forgot-password")}
              >
                {t("Forgot your password?")}
              </SecondaryButton>
              <PrimaryButton
                type="submit"
                onClick={submitForm}
                sx={{ width: 145 }}
              >
                {t("Login")}
              </PrimaryButton>
            </Grid>
            <Grid item>
              <StyledDivider />
            </Grid>
            <Grid item>
              <StyledTypography>
                {t(
                  "By continuing, you agree with the Privacy Policy and the Terms of Use. The site uses cookies as explained in the Privacy Policy."
                )}
              </StyledTypography>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default Login;
